/**
 * SearchInput — prymityw pola wyszukiwania (ikona lupy + Input z wcięciem).
 *
 * Ujednolica powtarzany wzorzec „relative div + lucide Search + Input pl-9" rozsiany po
 * ekranach z listami (słowniki tenanta i globalne, zakładki modułów…). Kontroler w górze:
 * `value` + `onChange(value)`. Margines/spacing sterowany przez `className` wrappera.
 */

import { Search } from 'lucide-react';

import { Input } from '@/components/Input';
import { cn } from '@/lib/utils';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Klasa wrappera (np. `mb-3` na odstęp pod polem). */
  className?: string;
  /** Nazwa pola dla czytnika ekranu — gdy samo `placeholder` (znika po wpisaniu) to za mało. */
  'aria-label'?: string;
  'data-testid'?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  className,
  'aria-label': ariaLabel,
  'data-testid': testId,
}: SearchInputProps) {
  return (
    <div className={cn('relative', className)}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-text-muted" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className="pl-9"
        data-testid={testId}
      />
    </div>
  );
}
